module.exports = __webpack_public_path__ + "static/media/cq_dopo_il_finanziamento b.586cf3e6.svg";